function getCurrentTime(player) {
  if (player !== null && player!==undefined) {
    return {"info": "currenttime", "value": [player.currentTime(), player.duration()]};
  }

}

function launch_pause(player) {
  if (player.paused()) {
    player.play();
  }
  else {
    player.pause();
  }
}

function launch_only_play(player) {
  if (player.paused()) {
    player.play();
  }
}

function launch_only_pause(player) {
  if (!player.paused()) {
    player.pause();
  }
}

function synchronize_inverse(player, time) {
  player.currentTime(time);
}
function moveToNextChapSld(player) {
  if (player !== null && player!==undefined) {
    window.parent.postMessage({
      "info": "moveToNextChapSld",
      "value": [Math.floor(player.currentTime()), parseInt( player.duration())]
    }, "*");
  }
}
function addInteractivity(player, content) {
  if (player !== null && player!==undefined) {
    window.parent.postMessage({
      "info": "addInteractivity",
      "value": [content]
    }, "*");
  }
}

function getEndedVideo(player) {
  if (player !== null && player!==undefined) {
    player.on('ended', function(event){
      window.parent.postMessage({"info": "endedVideo", value:  true}, "*");
    })
  }
}

export {getEndedVideo, getCurrentTime, launch_pause,launch_only_play,launch_only_pause , synchronize_inverse,moveToNextChapSld, addInteractivity};



// WEBPACK FOOTER //
// ./src/core/api/utilsClient.js